<template>
  <div class="grid grid-cols-2 sm:grid-cols-4 pt-6">
    <template v-if="ready">
      <div class="">
        <template v-if="widget.news_active">
          <nuxt-img
              width="343"
              height="412"
              format="webp"
              class="px-4 mb-3"
              :alt="widget.image"
              :src="siteURL+'/storage/images/widget-text-image/' +
                      widget.original_image"
          />
        </template>
        <template v-else>
          <img
              v-if="issue_cover.s3"
              width="343"
              height="412"
              class="px-4 mb-3"
              :src="issue_cover.s3"
              alt="current issue"
          />
        </template>
      </div>
      <div class="col-span-3 max-w-[580px]">
        <div class="mb-4">
          <h2 class="text-2xl font-bold leading-5">Print + Digital Access</h2>
          <p class="leading-5	">Renews automatically, cancel anytime.</p>
        </div>
        <ul v-for="offer in offers">
          <li class="flex py-2">
            <p class="font-bold grow">{{ offer.title }}</p>
            <p class="font-bold grow">
              <span class="ql-snow">
                <span class="p-imp-0 ql-editor">
                  <span v-html="offer.content"></span>
                </span>
              </span>
            </p>
            <p class="font-bold px-2.5">${{ offer.price }}</p>
            <button @click="addToCart(offer.id)" style="font-family: sans-serif; font-size: 11px"
                    class="bg-themeRed  text-white rounded-lg uppercase text-xs p-1.5">buy
              now
            </button>
          </li>
        </ul>
        <span class="ql-snow">
            <span class="ql-editor">
              <span class="mt-4" v-html="widget.description"></span>
            </span>
          </span>
      </div>
    </template>
    <template v-else>
      <LoadersSpinner/>
    </template>
  </div>
</template>

<script setup>
import {http} from "~/utils/http";
import {computed, ref} from "vue";
import {useMainStore} from "@/stores/main";
import {navigateTo} from "nuxt/app";
import {useSiteURL} from "../../composables/state";
import { Widget } from "~/composables/nhTypes";

const mainStore = useMainStore();
const offers = ref([]);
const issue_cover = ref('');
const ready = ref(false);
const cartProducts = computed(() => mainStore.cartProducts)
const widget = ref(new Widget);
const siteURL = useSiteURL();
const addToCart = async (id) => {
  let i = offers.value.map((item) => item.id).indexOf(id);
  mainStore.setProducts();

  let same_subs = cartProducts.value.filter((item) =>
      item.category === offers.value[i].type_id
      && item.category_option === offers.value[i].subscription_type);

  same_subs.forEach((item) => {
    mainStore.removeProduct({id: item.cartId});
  })

  let payload = {
    cartId: offers.value[i].id,
    product_id: offers.value[i].id,
    name: offers.value[i].title,
    price: offers.value[i].price,
    quantity: 1,
    category: offers.value[i].type_id,
    category_option: offers.value[i].subscription_type,
    product_type: offers.value[i].product_type,
    shipping_tax_ca: offers.value[i].shipping_tax_ca,
    shipping_tax_us: offers.value[i].shipping_tax_us,
    shipping_tax_za: offers.value[i].shipping_tax_za,
  }
  await mainStore.addProduct(payload);

  navigateTo('/checkout');
}
const getData = async () => {
  try {
    await http
        .get("/api/offers")
        .then((response) => {
          response.data.offers.forEach((offer) => {
            if (offer.type_id === 1 && offer.active === 1 && offer.price !== 0 && offer.visible_on_site === 1 && offer.subscription_type === 2) {
              offers.value.push(offer)
            }
          })
          ready.value = true;
        });
  } catch (e) {
  }
};

const getIssues = async () => {
  try {
    await http.get("/api/home").then((json) => {
      issue_cover.value = json.data.current_issue;
      widget.value = json.data.widget_subscribe;
      widget.value.news_active = !!widget.value.news_active;
      ready.value = true;
    });
  } catch (e) {
  }
};

getData();
getIssues();
</script>
